import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";

import 'react-loading-bar/dist/index.css';


let config = require('../Config/appConfig.json');

let self = null;
var captcha = null;
var url = config.SHARE_URL;
var title = config.SHARE_TITLE;
var source = config.SHARE_SOURCE;

@inject("appStore")
@observer
class MobileShare extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            showShare: "none",
            shareBtnTxt: "Share"
        };
    }

    componentWillMount = () => {
        self = this;


    }
    addNotifiation = (type, message) => {
        window.sendNotification(type, message)

    }

    componentDidMount = () => {

    }
    HandleShare = () => {
        console.log("handle share called")
        window.navigator.share({
            title,
            url
          }).then(() => {
            self.setState({ 
                shareBtnTxt: 'Thanks! 😄'
            });
          })
          .catch(err => {
            self.setState({ 
                shareBtnTxt: "Couldn't share"
            });
            
          });
    }




    render() {

        return (

            <div>
                <a href="javascript:void(0);" onClick={this.HandleShare} style={{marginTop:'1%'}} className="btn-get-the-app hover-box-effect">
                     Share
                </a>
            </div>
        );
    }
}

export default withRouter(MobileShare);


// WEBPACK FOOTER //
// ./src/Pages/MobileShare.js